import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { PER_ROW_SESSION_KEY } from '../../constants/perRowKeys';
import { itemsPerRow } from '../../configs';
import { useAlgoliaDataContext } from '../../hooks/useAlgoliaDataContext';
import { useAlgoliaDataStateContext } from '../../hooks/useAlgoliaDataStateContext';
import styles from './styles/Items.module.scss';
import { ItemsSkeleton } from './Items.skeleton';
import { ItemsComponent } from './Items.component';
export const Items = forwardRef((props, ref) => {
    const [perRow, setPerRow] = useState(() => {
        return window.sessionStorage.getItem(PER_ROW_SESSION_KEY) ?? itemsPerRow;
    });
    const { hits } = useAlgoliaDataContext();
    const { loading } = useAlgoliaDataStateContext();
    useImperativeHandle(ref, () => ({
        setPerRow(value) {
            if (value !== perRow) {
                setPerRow(value);
                window.sessionStorage.setItem(PER_ROW_SESSION_KEY, value);
            }
        }
    }));
    if (!loading && hits.length < 1) {
        return (React.createElement("div", { className: `text:center ${styles.emptyMessage}` },
            React.createElement("p", null, "No products were found")));
    }
    return loading ? React.createElement(ItemsSkeleton, { perRow: perRow }) : React.createElement(ItemsComponent, { perRow: perRow });
});
